import React from 'react'

export const ArticleHSL = () => {
  return (
    <div className="article">
      <h2 className="article-headline">
        HSL (Hue, Saturation, Lightness) - work in progress
      </h2>
      <p className="article.text"></p>
    </div>
  );
};
